import { createTheme } from "@mui/material/styles";

export default function lightTheme(themes) {

  return createTheme({
    typography: {
      fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
    },
    palette: {
      background: {},
      primary: {
        main: (themes || []).find(v => v.name === 'color_main1' && !v.default)?.value || "#E25640",
        state: "#D81B60",
        contrastText: "#FFFFFF"
      },
      secondary: {
        main: "#9CA0A0",
        state: "#D81B60",
        contrastText: "#FFFFFF"
      },
      error: {
        main: "#E25640",
        state: "#B22640",
        contrastText: "#FFFFFF"
      },
      info: {
        main: "#FFEEED",
        state: "#D81B60",
        contrastText: "#FFFFFF",
      },
      body: {
        main: "#000000",
        state: "#D81B60",
        contrastText: "#FFFFFF"
      },
      light: {
        main: "#F9F5FB",
        state: "#D81B60",
        contrastText: "#FFFFFF"
      },
    },
  });
}